import filter from "lodash/filter"
import find from "lodash/find"
import isEqual from "react-fast-compare"
import { isEmptyHTML } from "../../utils"

export const getTasklistProgress = (tasks, completedTasks = []) => {
  return {
    complete: completedTasks.length,
    total: removeEmptyTasks(tasks).length
  }
}

export const isComplete = (task, completedTasks = []) => {
  const inCompleted = find(completedTasks, task)
  return !!inCompleted
}

export const createSampleTodo = (order) => {
  return {
    order,
    content: `<p>Task no. ${order}</p>`
  }
}

export const addNewTask = (tasks) => {
  const hasEmpty = !!find(tasks, (t) => t.content === "")
  if (!hasEmpty) {
    return [...(tasks || []), { content: "", order: (tasks || []).length + 1 }]
  }
  return tasks
}

export const removeEmptyTasks = (tasks) => {
  return tasks ? tasks.filter((t) => !isEmptyHTML(t.content)) : []
}

export const removeNewTask = (tasks) => {
  return tasks ? tasks.filter((t) => t.content !== "") : []
}

export const toggleComplete = (task, data) => {
  const { completedTasks } = data

  let nextCompletedTasks = []

  const currentCompletedItem = find(completedTasks, task)

  if (currentCompletedItem) {
    nextCompletedTasks = filter(completedTasks, (t) => {
      return t.order !== task.order && t.content !== task.content
    })
    // nextCompletedTasks = filter(completedTasks, !task)
  } else {
    nextCompletedTasks = completedTasks
      ? completedTasks.concat([{ ...task }])
      : [{ ...task }]
  }

  return nextCompletedTasks
}

// Return updated completedTasks or undefined if no change
export const updateCompleted = (data) => {
  const { completedTasks, tasks } = data

  if (!completedTasks || !completedTasks.length) return
  if (isEqual(tasks, completedTasks)) return

  const nextCompletedTasks = completedTasks.filter(
    (t) => !!find(tasks, { content: t.content })
  )

  const reorderedTasks = reorderCompletedTasks(nextCompletedTasks, tasks)

  return reorderedTasks
}

export const reorderCompletedTasks = (completedTasks, items) => {
  const nextCompletedTasks = completedTasks.map((t) => {
    const reorderedTask = find(items, { content: t.content })

    return {
      ...t,
      order: reorderedTask.order
    }
  })

  return nextCompletedTasks
}
